import React, { createContext, useState, useContext } from 'react';

const AlertContext = createContext();

export const useAlertContext = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
	const [alerts, setAlerts] = useState([]);

	const showAlert = (message, type = 'danger', timeout = 5000) => {
		const id = Date.now().toString();

		const newAlert = {
			id,
			message,
			type,
		};

		setAlerts((prevAlerts) => [...prevAlerts, newAlert]);

		if (timeout > 0) {
			setTimeout(() => {
				dismissAlert(id);
			}, timeout);
		}

		return id;
	};

	const dismissAlert = (id) => {
		setAlerts((prevAlerts) => prevAlerts.filter((alert) => alert.id !== id));
	};

	const clearAlerts = () => {
		setAlerts([]);
	};

	const value = {
		alerts,
		showAlert,
		dismissAlert,
		clearAlerts,
	};

	return (
		<AlertContext.Provider value={value}>{children}</AlertContext.Provider>
	);
};
